// removed by extract-text-webpack-plugin
module.exports = {"blockquote":"src-components-HomeSlider----HomeSlider-module---blockquote---3YjX1","sliderArrow":"src-components-HomeSlider----HomeSlider-module---sliderArrow---1wNU0","slideritem":"src-components-HomeSlider----HomeSlider-module---slideritem---3n_pQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeSlider/HomeSlider.module.scss
// module id = 420
// module chunks = 213534597649335